import React from "react";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import CustomBtn from "../ButtonTemplate";

interface WhitelistBtnProps {
  action: () => void;
  addToList?: boolean;
}

function WhitelistBtn({ action, addToList = true }: WhitelistBtnProps) {
  const buttonStyles = addToList ? {
    "&:hover": {},
  } : {
    backgroundColor: "#C0C0C0",
    "&:hover": {
      background: "#DCDCDC",
    },
  };

  return (
    <CustomBtn
      sx={buttonStyles}
      action={action}
      type="light"
      icon={<HowToRegIcon />}
      tip={addToList ? "Whitelist Player" : "Remove from Whitelist"}
    />
  );
}

export default WhitelistBtn;
